<template>
    <div>
        <app-title text="PQR's Asignadas" />
        <app-petition-filters @filter="onFilter" :is-assigned="true" />
        <app-table-assigned-petitions
            :data="data"
            :on-change-page="onChangePage"
            :see-comments-by-petition="seeCommentsByPetition"
            :see-more="seeMore"
            :start-add-comment="startAddComment"
            :start-re-assign-user-to-petition="startReAssignUserToPetition"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->

        <app-pop-up
            title="Comentarios de la petición"
            size="large"
            id="view-comments-petition-assigned-petitions"
        >
            <div class="body" slot="body">
                <app-petition-comments-list
                    :onRemove="onRemoveComment"
                    :comments="commentsPetitionSelect"
                />
            </div>
        </app-pop-up>

        <app-pop-up
            title="Asignación de usuario a la petición"
            id="petition-assignment-assigned-petitions"
            :on-close="clean"
        >
            <div class="body" slot="body">
                <app-form-select-input
                    label="Seleccione cargo"
                    :options="positions"
                    v-model="positionId"
                    @change="
                        !!positionId ? loadUsersByPosition(positionId) : clean()
                    "
                />
                <app-form-select-input
                    label="Seleccione usuario"
                    :options="users"
                    v-model="assignation.userId"
                    :hasError="$v.assignation.userId.$error"
                    errorMessage="Debe seleccionar el usuario"
                    @change="$v.assignation.userId.$touch()"
                    :required="true"
                />

                <app-date-picker
                    label="Fecha de vencimiento"
                    :with-time="false"
                    v-model="assignation.dueDate"
                    :required="true"
                    :hasError="$v.assignation.dueDate.$error"
                    errorMessage="Debe seleccionar la fecha de vencimiento"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="assignUserToPetition()"
                >
                    Asignar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up id="view-petition-more-assigned-petitions" title="Petición">
            <div slot="body">
                <div class="row">
                    <div class="col-6">
                        <h5>Fecha de creación</h5>
                        <label>{{ petitionView.date | datetime }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Tipo de petición</h5>
                        <label>{{ petitionView.type }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Cliente</h5>
                        <label>{{ petitionView.client }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Usuario</h5>
                        <label>{{ petitionView.user }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Estado</h5>
                        <label>{{ petitionView.status }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Usuarios asignados</h5>
                        <div v-if="petitionView.assignments">
                            <div v-for="assignment in petitionView.assignments">
                                {{
                                    assignment.inactive
                                        ? assignment.user.name
                                        : assignment.user.name +
                                          " (Actualmente)"
                                }}
                            </div>
                        </div>
                        <div v-if="!petitionView.assignments.length">
                            No tiene
                        </div>
                    </div>
                </div>
                <br />
                <h5 style="text-align:center">
                    <label for="anotation">Descripción</label>
                </h5>
                <textarea
                    type="text"
                    id="anotation"
                    class="form-control"
                    disabled="true"
                    cols="80"
                    rows="8"
                    v-model="petitionView.description"
                ></textarea>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Agregar comentario a la petición"
            id="petition-comment-assigned-petitions"
            :onClose="cleanFormComment"
        >
            <div class="body" slot="body">
                <app-add-petition-comment
                    id="petition-comment-assigned-petitions"
                    :petition="petitionComment"
                    :on-save="onSaveComment"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="
                        $bus.$emit('petition-comment-assigned-petitions.save')
                    "
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <!-- fin de pop ups -->
    </div>
</template>
<script>
import petitionsRepository from "../../../repositories/petitions.repository.js";
import userRepository from "../../../repositories/users.repository.js";
import AddPetitionComment from "../PetitionComment/AddPetitionComment.vue";
import { required } from "vuelidate/lib/validators";
import DatePicker from "../../UI/Controls/DateTimePicker/DateTimePicker.vue";
import { mapGetters } from "vuex";
import TableAssignedPetitions from "./TableAssignedPetitions/TableAssignedPetitions.vue";
import PetitionFilters from "../PetitionFilters/PetitionFilters.vue";
import PetitionCommentsList from "../PetitionComment/PetitionCommentsList";
export default {
    components: {
        appAddPetitionComment: AddPetitionComment,
        appDatePicker: DatePicker,
        appTableAssignedPetitions: TableAssignedPetitions,
        appPetitionFilters: PetitionFilters,
        appPetitionCommentsList: PetitionCommentsList
    },

    data() {
        return {
            petitionView: {
                user: "",
                client: "",
                type: "",
                date: "",
                description: "",
                status: "",
                assignments: []
            },
            commentsPetitionSelect: [],
            data: {},
            assignation: {
                userId: "",
                petitionId: "",
                assignedBy: "",
                dueDate: null
            },
            petitionComment: {},
            users: [],
            positionId: "",
            page: 1,
            sort: {
                sortBy: "created_at",
                sortDir: "asc"
            },
            filters: {}
        };
    },

    validations: {
        assignation: {
            userId: { required },
            petitionId: { required },
            dueDate: { required }
        }
    },
    computed: {
        ...mapGetters(["positions"])
    },
    methods: {
        petitionColorStatus(petition) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dueDate = new Date(petition.due_date);
            dueDate.setHours(0, 0, 0, 0);
            if (today.getTime() === dueDate.getTime() && petition.resolved != 1)
                return "today";
            if (dueDate.getTime() < today.getTime() && petition.resolved != 1)
                return "overdue";
        },
        loadPetitions() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir
            };
            const pr = Object.assign({}, petitionsRepository);
            pr.loadPetitionsAssigned(filters, this.page)
                .then(data => {
                    this.data = data;
                })
                .catch(error =>
                    toastr.error("Error al cargar las peticiones pendientes")
                );
        },
        onChangePage(page) {
            this.page = page;
            this.loadPetitions();
        },
        loadUsersByPosition(positionId) {
            this.assignation.userId = "";
            this.$v.$reset();
            const ur = Object.assign({}, userRepository);
            ur.loadUsersByPosition(positionId)
                .then(data => {
                    this.users = data;
                    if (this.users.length == 1) {
                        this.assignation.userId = this.users[0].id;
                    }
                })
                .catch(error => {
                    toastr.error("Error al cargar los usuarios de este cargo");
                });
        },
        seeMore(petition) {
            Object.keys(this.petitionView).map(
                key => (this.petitionView[key] = "")
            );
            this.petitionView.user = petition.user.name;
            this.petitionView.client = petition.client.name;
            this.petitionView.type = petition.petition_type.name;
            this.petitionView.date = petition.created_at;
            this.petitionView.description = petition.description;
            this.petitionView.status = petition.petition_status.name;
            this.petitionView.assignments = petition.petition_assignment;

            this.$bus.$emit("view-petition-more-assigned-petitions.open");
        },
        seeCommentsByPetition(petition) {
            this.commentsPetitionSelect = petition.comments;
            this.$bus.$emit("view-comments-petition-assigned-petitions.open");
        },
        startReAssignUserToPetition(petition) {
            this.assignation.dueDate = petition.due_date;
            this.assignation.petitionId = petition.id;
            this.$bus.$emit("petition-assignment-assigned-petitions.open");
        },
        clean() {
            this.users = [];
            this.positionId = "";
            this.assignation.userId = "";
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        assignUserToPetition() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            this.assignation.assignedBy = this.user.id;
            const pr = Object.assign({}, petitionsRepository);
            pr.saveAssignation(this.assignation)
                .then(data => {
                    if (data.status) {
                        this.clean();
                        this.assignation.petitionId = "";
                        this.loadPetitions();
                        this.$bus.$emit(
                            "petition-assignment-assigned-petitions.close"
                        );
                        toastr.success(data.msg);
                    } else {
                        toastr.warning(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Error al asignar usuario");
                });
        },
        startAddComment(petition) {
            this.petitionComment = petition;
            this.$bus.$emit("petition-comment-assigned-petitions.open");
        },
        onSaveComment() {
            this.$bus.$emit("petition-comment-assigned-petitions.close");
            this.loadPetitions();
        },
        cleanFormComment() {
            this.$bus.$emit("petition-comment-assigned-petitions.clean");
        },
        onRemoveComment() {
            if (!this.commentsPetitionSelect.length) {
                this.$bus.$emit(
                    "view-comments-petition-assigned-petitions.close"
                );
            }
        },
        onFilter(filters) {
            this.filters = filters;
            this.loadPetitions();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadPetitions();
        }
    },

    created() {
        this.loadPetitions();
    }
};
</script>
